module.exports = __webpack_public_path__ + "img/axle_conf_3.c9c2149b.jpg";